import { Observable, Subject, defer, distinctUntilChanged, map, shareReplay, startWith, switchMap } from 'rxjs';

export interface IdbaLookupRequest {
  procedure: string;
  parameters: Record<string, unknown>;
}

export type IdbaLookupRequestLoader<T> =
  (request: IdbaLookupRequest) => Observable<readonly T[]>;

export class IdbaLookupDataSource<T> {
  private readonly requestSubject = new Subject<{ request: IdbaLookupRequest; force: boolean }>();

  readonly options$: Observable<readonly T[]>;

  private readonly loader: IdbaLookupRequestLoader<T>;
  private readonly initialRequest: IdbaLookupRequest;

  constructor(
    loader: IdbaLookupRequestLoader<T>,
    initialRequest: IdbaLookupRequest,
  ) {
    this.loader = loader;
    this.initialRequest = initialRequest;
    this.options$ = this.requestSubject.pipe(
      startWith({ request: this.initialRequest, force: false }),
      distinctUntilChanged((previous, current) =>
        !current.force && this.signature(previous.request) === this.signature(current.request),
      ),
      switchMap(({ request }) => defer(() => this.loader(request))),
      map((options) => options ?? []),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  reload(request: IdbaLookupRequest, force = false): void {
    this.requestSubject.next({ request, force });
  }

  private signature(request: IdbaLookupRequest): string {
    return JSON.stringify(request);
  }
}
